import type { EDetectorType } from '@web/entities/measurement/model/enums/detector-type.enum.ts'
import type { EOverlayType } from '@web/entities/measurement/model/enums/overlap-type.enum.ts'

export const mapOverlayType: { [key in EOverlayType]: string } = {
  COUNT_0: '0',
  COUNT_10: '10',
  COUNT_20: '20',
  COUNT_30: '30',
  COUNT_40: '40',
  COUNT_50: '50',
  COUNT_65: '65',
  COUNT_75: '75'
} as const

export const overlayTypeOptions = Object.entries(mapOverlayType).map(
  ([key, label]) => ({
    value: key as EDetectorType,
    label
  })
)
